import React from "react";

export default function RenewCertInsertToken() {
  return (
    <div
      style={{
        paddingBottom: "300px",
        textAlign: "center",
        width: "100%",
        fontSize: "20px",
      }}
    >
      <b>
        Vui lòng rút token cắm lại và nhập mã PIN
        <br />
        để thực hiện cấp bù chứng thư số
      </b>
    </div>
  );
}
